import React, { useState } from "react";
import { X } from "lucide-react";
import Button, { ButtonType } from "../Assets/Button";

interface TaskManagerDateExtensionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (requestedEndDate: Date) => void;
  currentEndDate?: Date | null;
}

const TaskManagerDateExtensionModal: React.FC<
  TaskManagerDateExtensionModalProps
> = ({ isOpen, onClose, onSubmit, currentEndDate }) => {
  const [requestedEndDate, setRequestedEndDate] = useState<string>("");

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (!requestedEndDate) {
      alert("Please select a date");
      return;
    }

    onSubmit(new Date(requestedEndDate));
    setRequestedEndDate("");
  };

  const getMinDate = () => {
    if (currentEndDate) {
      const nextDay = new Date(currentEndDate);
      nextDay.setDate(nextDay.getDate() + 1);
      return nextDay.toISOString().split("T")[0];
    }
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split("T")[0];
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-sm font-semibold">Extend Task Deadline</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="mb-4">
          <label className="block text-xs font-medium text-gray-700 mb-2">
            Current End Date:{" "}
            {currentEndDate
              ? new Date(currentEndDate).toLocaleDateString()
              : "Not set"}
          </label>
          <label className="block text-xs font-medium text-gray-700 mb-2">
            Extend End Date
          </label>
          <input
            type="date"
            value={requestedEndDate}
            onChange={(e) => setRequestedEndDate(e.target.value)}
            min={getMinDate()}
            className="w-full text-xs px-3 py-1.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="flex justify-end gap-3">
          <Button
            type={ButtonType.Cancel}
            onClick={onClose}
            className="text-xs"
          >
            Cancel
          </Button>
          <Button
            type={ButtonType.Submit}
            onClick={handleSubmit}
            className="text-xs"
          >
            Update
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TaskManagerDateExtensionModal;
